<div class="text-center">
  <fa-icon [icon]="['fas', 'check-circle']" class="icon"></fa-icon>
  <h1>Thank You</h1>
  <h2>Your form was submitted successfully.</h2>
    <p style="font-size:24px">One of our staff will reach out to you shortly.</p>
    <br/>
    <button class="btn btn-primary" type="button" (click)="close()">Close</button>
</div>
